// Auto-generated 150 Thematic Generative Artworks Collection
export interface GenerativeArtEntry {
  id: string;
  plate_number: number;
  title: string;
  cycle_id: string;
  cycle_title: string;
  act: string;
  description: string;
  file_name: string;
  relative_path: string;
  width: number;
  height: number;
  aspect_ratio: string;
}

export const GENERATIVE_ART_COLLECTION: GenerativeArtEntry[] = [
  {
    "id": "art_001",
    "plate_number": 1,
    "title": "Dorsal Spine-Rail Magnetic Accelerator",
    "cycle_id": "01_geryon_superstructure",
    "cycle_title": "USSC Geryon Deep-Space Superstructure",
    "act": "Act I & II",
    "description": "Twelve kilometers of blackened industrial leviathan thundering through deep vacuum, dragging chained iron asteroids.",
    "file_name": "caesura_art_001_01_geryon_superstructure.jpg",
    "relative_path": "/art/generative/caesura_art_001_01_geryon_superstructure.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_002",
    "plate_number": 2,
    "title": "Titanium Keel Gantry at Kilo-Eleven",
    "cycle_id": "01_geryon_superstructure",
    "cycle_title": "USSC Geryon Deep-Space Superstructure",
    "act": "Act I & II",
    "description": "Twelve kilometers of blackened industrial leviathan thundering through deep vacuum, dragging chained iron asteroids.",
    "file_name": "caesura_art_002_01_geryon_superstructure.jpg",
    "relative_path": "/art/generative/caesura_art_002_01_geryon_superstructure.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_003",
    "plate_number": 3,
    "title": "Chained Asteroid Haul Shackles",
    "cycle_id": "01_geryon_superstructure",
    "cycle_title": "USSC Geryon Deep-Space Superstructure",
    "act": "Act I & II",
    "description": "Twelve kilometers of blackened industrial leviathan thundering through deep vacuum, dragging chained iron asteroids.",
    "file_name": "caesura_art_003_01_geryon_superstructure.jpg",
    "relative_path": "/art/generative/caesura_art_003_01_geryon_superstructure.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_004",
    "plate_number": 4,
    "title": "Forward Deflector Needle & Cryo-Pylons",
    "cycle_id": "01_geryon_superstructure",
    "cycle_title": "USSC Geryon Deep-Space Superstructure",
    "act": "Act I & II",
    "description": "Twelve kilometers of blackened industrial leviathan thundering through deep vacuum, dragging chained iron asteroids.",
    "file_name": "caesura_art_004_01_geryon_superstructure.jpg",
    "relative_path": "/art/generative/caesura_art_004_01_geryon_superstructure.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_005",
    "plate_number": 5,
    "title": "Sector Four Superconducting Conduits",
    "cycle_id": "01_geryon_superstructure",
    "cycle_title": "USSC Geryon Deep-Space Superstructure",
    "act": "Act I & II",
    "description": "Twelve kilometers of blackened industrial leviathan thundering through deep vacuum, dragging chained iron asteroids.",
    "file_name": "caesura_art_005_01_geryon_superstructure.jpg",
    "relative_path": "/art/generative/caesura_art_005_01_geryon_superstructure.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_006",
    "plate_number": 6,
    "title": "Vented Hydrazine Reaction Thrusters",
    "cycle_id": "01_geryon_superstructure",
    "cycle_title": "USSC Geryon Deep-Space Superstructure",
    "act": "Act I & II",
    "description": "Twelve kilometers of blackened industrial leviathan thundering through deep vacuum, dragging chained iron asteroids.",
    "file_name": "caesura_art_006_01_geryon_superstructure.jpg",
    "relative_path": "/art/generative/caesura_art_006_01_geryon_superstructure.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_007",
    "plate_number": 7,
    "title": "Magnetic Rail-Skate Tube Network",
    "cycle_id": "01_geryon_superstructure",
    "cycle_title": "USSC Geryon Deep-Space Superstructure",
    "act": "Act I & II",
    "description": "Twelve kilometers of blackened industrial leviathan thundering through deep vacuum, dragging chained iron asteroids.",
    "file_name": "caesura_art_007_01_geryon_superstructure.jpg",
    "relative_path": "/art/generative/caesura_art_007_01_geryon_superstructure.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_008",
    "plate_number": 8,
    "title": "Slag-Trap Reactor Exhaust Manifold",
    "cycle_id": "01_geryon_superstructure",
    "cycle_title": "USSC Geryon Deep-Space Superstructure",
    "act": "Act I & II",
    "description": "Twelve kilometers of blackened industrial leviathan thundering through deep vacuum, dragging chained iron asteroids.",
    "file_name": "caesura_art_008_01_geryon_superstructure.jpg",
    "relative_path": "/art/generative/caesura_art_008_01_geryon_superstructure.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_009",
    "plate_number": 9,
    "title": "Armor Plating Disassembly Trench",
    "cycle_id": "01_geryon_superstructure",
    "cycle_title": "USSC Geryon Deep-Space Superstructure",
    "act": "Act I & II",
    "description": "Twelve kilometers of blackened industrial leviathan thundering through deep vacuum, dragging chained iron asteroids.",
    "file_name": "caesura_art_009_01_geryon_superstructure.jpg",
    "relative_path": "/art/generative/caesura_art_009_01_geryon_superstructure.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_010",
    "plate_number": 10,
    "title": "Stern Fusion Core Radiator Spine",
    "cycle_id": "01_geryon_superstructure",
    "cycle_title": "USSC Geryon Deep-Space Superstructure",
    "act": "Act I & II",
    "description": "Twelve kilometers of blackened industrial leviathan thundering through deep vacuum, dragging chained iron asteroids.",
    "file_name": "caesura_art_010_01_geryon_superstructure.jpg",
    "relative_path": "/art/generative/caesura_art_010_01_geryon_superstructure.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_011",
    "plate_number": 11,
    "title": "Bridge Command Armored Glass Monolith",
    "cycle_id": "01_geryon_superstructure",
    "cycle_title": "USSC Geryon Deep-Space Superstructure",
    "act": "Act I & II",
    "description": "Twelve kilometers of blackened industrial leviathan thundering through deep vacuum, dragging chained iron asteroids.",
    "file_name": "caesura_art_011_01_geryon_superstructure.jpg",
    "relative_path": "/art/generative/caesura_art_011_01_geryon_superstructure.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_012",
    "plate_number": 12,
    "title": "Hawser-Walker Inspection Catwalk",
    "cycle_id": "01_geryon_superstructure",
    "cycle_title": "USSC Geryon Deep-Space Superstructure",
    "act": "Act I & II",
    "description": "Twelve kilometers of blackened industrial leviathan thundering through deep vacuum, dragging chained iron asteroids.",
    "file_name": "caesura_art_012_01_geryon_superstructure.jpg",
    "relative_path": "/art/generative/caesura_art_012_01_geryon_superstructure.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_013",
    "plate_number": 13,
    "title": "Kilo-Nine Tribunal Vault Bulkheads",
    "cycle_id": "01_geryon_superstructure",
    "cycle_title": "USSC Geryon Deep-Space Superstructure",
    "act": "Act I & II",
    "description": "Twelve kilometers of blackened industrial leviathan thundering through deep vacuum, dragging chained iron asteroids.",
    "file_name": "caesura_art_013_01_geryon_superstructure.jpg",
    "relative_path": "/art/generative/caesura_art_013_01_geryon_superstructure.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_014",
    "plate_number": 14,
    "title": "Perseus Buoy Lidar Telemetry Spire",
    "cycle_id": "01_geryon_superstructure",
    "cycle_title": "USSC Geryon Deep-Space Superstructure",
    "act": "Act I & II",
    "description": "Twelve kilometers of blackened industrial leviathan thundering through deep vacuum, dragging chained iron asteroids.",
    "file_name": "caesura_art_014_01_geryon_superstructure.jpg",
    "relative_path": "/art/generative/caesura_art_014_01_geryon_superstructure.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_015",
    "plate_number": 15,
    "title": "Vitrified Titanium Hull Lattice",
    "cycle_id": "01_geryon_superstructure",
    "cycle_title": "USSC Geryon Deep-Space Superstructure",
    "act": "Act I & II",
    "description": "Twelve kilometers of blackened industrial leviathan thundering through deep vacuum, dragging chained iron asteroids.",
    "file_name": "caesura_art_015_01_geryon_superstructure.jpg",
    "relative_path": "/art/generative/caesura_art_015_01_geryon_superstructure.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_016",
    "plate_number": 16,
    "title": "Bus Four Four-Hundred-Amp Grounding Jaw",
    "cycle_id": "02_conduit_crawlways",
    "cycle_title": "Superconducting Conduit Crawlways",
    "act": "Act III",
    "description": "High-voltage gantry crawlways, glowing copper busbars, petawatt corona arcs, and burnt ozone haze.",
    "file_name": "caesura_art_016_02_conduit_crawlways.jpg",
    "relative_path": "/art/generative/caesura_art_016_02_conduit_crawlways.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_017",
    "plate_number": 17,
    "title": "Liquid Nitrogen Arc-Fault Detonation",
    "cycle_id": "02_conduit_crawlways",
    "cycle_title": "Superconducting Conduit Crawlways",
    "act": "Act III",
    "description": "High-voltage gantry crawlways, glowing copper busbars, petawatt corona arcs, and burnt ozone haze.",
    "file_name": "caesura_art_017_02_conduit_crawlways.jpg",
    "relative_path": "/art/generative/caesura_art_017_02_conduit_crawlways.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_018",
    "plate_number": 18,
    "title": "Cerulean Corona Bleed Across Sector 7",
    "cycle_id": "02_conduit_crawlways",
    "cycle_title": "Superconducting Conduit Crawlways",
    "act": "Act III",
    "description": "High-voltage gantry crawlways, glowing copper busbars, petawatt corona arcs, and burnt ozone haze.",
    "file_name": "caesura_art_018_02_conduit_crawlways.jpg",
    "relative_path": "/art/generative/caesura_art_018_02_conduit_crawlways.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_019",
    "plate_number": 19,
    "title": "Braided Copper Keel Grounding Whip",
    "cycle_id": "02_conduit_crawlways",
    "cycle_title": "Superconducting Conduit Crawlways",
    "act": "Act III",
    "description": "High-voltage gantry crawlways, glowing copper busbars, petawatt corona arcs, and burnt ozone haze.",
    "file_name": "caesura_art_019_02_conduit_crawlways.jpg",
    "relative_path": "/art/generative/caesura_art_019_02_conduit_crawlways.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_020",
    "plate_number": 20,
    "title": "Hydraulic Phase-Baffle Commutator",
    "cycle_id": "02_conduit_crawlways",
    "cycle_title": "Superconducting Conduit Crawlways",
    "act": "Act III",
    "description": "High-voltage gantry crawlways, glowing copper busbars, petawatt corona arcs, and burnt ozone haze.",
    "file_name": "caesura_art_020_02_conduit_crawlways.jpg",
    "relative_path": "/art/generative/caesura_art_020_02_conduit_crawlways.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_021",
    "plate_number": 21,
    "title": "Fifty-Three Picosecond Bevel Tolerance",
    "cycle_id": "02_conduit_crawlways",
    "cycle_title": "Superconducting Conduit Crawlways",
    "act": "Act III",
    "description": "High-voltage gantry crawlways, glowing copper busbars, petawatt corona arcs, and burnt ozone haze.",
    "file_name": "caesura_art_021_02_conduit_crawlways.jpg",
    "relative_path": "/art/generative/caesura_art_021_02_conduit_crawlways.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_022",
    "plate_number": 22,
    "title": "Ozone Mist Caught in Halogen Light",
    "cycle_id": "02_conduit_crawlways",
    "cycle_title": "Superconducting Conduit Crawlways",
    "act": "Act III",
    "description": "High-voltage gantry crawlways, glowing copper busbars, petawatt corona arcs, and burnt ozone haze.",
    "file_name": "caesura_art_022_02_conduit_crawlways.jpg",
    "relative_path": "/art/generative/caesura_art_022_02_conduit_crawlways.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_023",
    "plate_number": 23,
    "title": "Superconducting Lithium Plume Channel",
    "cycle_id": "02_conduit_crawlways",
    "cycle_title": "Superconducting Conduit Crawlways",
    "act": "Act III",
    "description": "High-voltage gantry crawlways, glowing copper busbars, petawatt corona arcs, and burnt ozone haze.",
    "file_name": "caesura_art_023_02_conduit_crawlways.jpg",
    "relative_path": "/art/generative/caesura_art_023_02_conduit_crawlways.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_024",
    "plate_number": 24,
    "title": "Sub-Deck Breaker Bank Catastrophe",
    "cycle_id": "02_conduit_crawlways",
    "cycle_title": "Superconducting Conduit Crawlways",
    "act": "Act III",
    "description": "High-voltage gantry crawlways, glowing copper busbars, petawatt corona arcs, and burnt ozone haze.",
    "file_name": "caesura_art_024_02_conduit_crawlways.jpg",
    "relative_path": "/art/generative/caesura_art_024_02_conduit_crawlways.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_025",
    "plate_number": 25,
    "title": "Secondary Grounding Cable Snap-Back",
    "cycle_id": "02_conduit_crawlways",
    "cycle_title": "Superconducting Conduit Crawlways",
    "act": "Act III",
    "description": "High-voltage gantry crawlways, glowing copper busbars, petawatt corona arcs, and burnt ozone haze.",
    "file_name": "caesura_art_025_02_conduit_crawlways.jpg",
    "relative_path": "/art/generative/caesura_art_025_02_conduit_crawlways.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_026",
    "plate_number": 26,
    "title": "High-Voltage Ceramic Insulator Spire",
    "cycle_id": "02_conduit_crawlways",
    "cycle_title": "Superconducting Conduit Crawlways",
    "act": "Act III",
    "description": "High-voltage gantry crawlways, glowing copper busbars, petawatt corona arcs, and burnt ozone haze.",
    "file_name": "caesura_art_026_02_conduit_crawlways.jpg",
    "relative_path": "/art/generative/caesura_art_026_02_conduit_crawlways.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_027",
    "plate_number": 27,
    "title": "Emergency Quench Valve Rupture",
    "cycle_id": "02_conduit_crawlways",
    "cycle_title": "Superconducting Conduit Crawlways",
    "act": "Act III",
    "description": "High-voltage gantry crawlways, glowing copper busbars, petawatt corona arcs, and burnt ozone haze.",
    "file_name": "caesura_art_027_02_conduit_crawlways.jpg",
    "relative_path": "/art/generative/caesura_art_027_02_conduit_crawlways.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_028",
    "plate_number": 28,
    "title": "Forty-Four-Hertz Busbar Hum Resonance",
    "cycle_id": "02_conduit_crawlways",
    "cycle_title": "Superconducting Conduit Crawlways",
    "act": "Act III",
    "description": "High-voltage gantry crawlways, glowing copper busbars, petawatt corona arcs, and burnt ozone haze.",
    "file_name": "caesura_art_028_02_conduit_crawlways.jpg",
    "relative_path": "/art/generative/caesura_art_028_02_conduit_crawlways.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_029",
    "plate_number": 29,
    "title": "Titanium Cheater Bar Jammed in Hinge",
    "cycle_id": "02_conduit_crawlways",
    "cycle_title": "Superconducting Conduit Crawlways",
    "act": "Act III",
    "description": "High-voltage gantry crawlways, glowing copper busbars, petawatt corona arcs, and burnt ozone haze.",
    "file_name": "caesura_art_029_02_conduit_crawlways.jpg",
    "relative_path": "/art/generative/caesura_art_029_02_conduit_crawlways.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_030",
    "plate_number": 30,
    "title": "Vaporized Lead-Bismuth Heat Exchanger",
    "cycle_id": "02_conduit_crawlways",
    "cycle_title": "Superconducting Conduit Crawlways",
    "act": "Act III",
    "description": "High-voltage gantry crawlways, glowing copper busbars, petawatt corona arcs, and burnt ozone haze.",
    "file_name": "caesura_art_030_02_conduit_crawlways.jpg",
    "relative_path": "/art/generative/caesura_art_030_02_conduit_crawlways.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_031",
    "plate_number": 31,
    "title": "Non-Euclidean Planck Shearing Threshold",
    "cycle_id": "03_caesura_deadband",
    "cycle_title": "The 53-Picosecond Caesura Dead-Band Abyss",
    "act": "Act IV & V",
    "description": "The infinitesimal gap between Planck seconds where matter is unthreaded, light freezes, and coordinates rewire.",
    "file_name": "caesura_art_031_03_caesura_deadband.jpg",
    "relative_path": "/art/generative/caesura_art_031_03_caesura_deadband.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_032",
    "plate_number": 32,
    "title": "Suspended Particulate Diamond Foam",
    "cycle_id": "03_caesura_deadband",
    "cycle_title": "The 53-Picosecond Caesura Dead-Band Abyss",
    "act": "Act IV & V",
    "description": "The infinitesimal gap between Planck seconds where matter is unthreaded, light freezes, and coordinates rewire.",
    "file_name": "caesura_art_032_03_caesura_deadband.jpg",
    "relative_path": "/art/generative/caesura_art_032_03_caesura_deadband.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_033",
    "plate_number": 33,
    "title": "Temporal Freeze Horizon Inside the Gap",
    "cycle_id": "03_caesura_deadband",
    "cycle_title": "The 53-Picosecond Caesura Dead-Band Abyss",
    "act": "Act IV & V",
    "description": "The infinitesimal gap between Planck seconds where matter is unthreaded, light freezes, and coordinates rewire.",
    "file_name": "caesura_art_033_03_caesura_deadband.jpg",
    "relative_path": "/art/generative/caesura_art_033_03_caesura_deadband.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_034",
    "plate_number": 34,
    "title": "Frozen Lithium Droplet Inversion",
    "cycle_id": "03_caesura_deadband",
    "cycle_title": "The 53-Picosecond Caesura Dead-Band Abyss",
    "act": "Act IV & V",
    "description": "The infinitesimal gap between Planck seconds where matter is unthreaded, light freezes, and coordinates rewire.",
    "file_name": "caesura_art_034_03_caesura_deadband.jpg",
    "relative_path": "/art/generative/caesura_art_034_03_caesura_deadband.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_035",
    "plate_number": 35,
    "title": "Unrendered Matter Coordinate Dispersal",
    "cycle_id": "03_caesura_deadband",
    "cycle_title": "The 53-Picosecond Caesura Dead-Band Abyss",
    "act": "Act IV & V",
    "description": "The infinitesimal gap between Planck seconds where matter is unthreaded, light freezes, and coordinates rewire.",
    "file_name": "caesura_art_035_03_caesura_deadband.jpg",
    "relative_path": "/art/generative/caesura_art_035_03_caesura_deadband.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_036",
    "plate_number": 36,
    "title": "Zero-Tick Static Electricity Mirage",
    "cycle_id": "03_caesura_deadband",
    "cycle_title": "The 53-Picosecond Caesura Dead-Band Abyss",
    "act": "Act IV & V",
    "description": "The infinitesimal gap between Planck seconds where matter is unthreaded, light freezes, and coordinates rewire.",
    "file_name": "caesura_art_036_03_caesura_deadband.jpg",
    "relative_path": "/art/generative/caesura_art_036_03_caesura_deadband.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_037",
    "plate_number": 37,
    "title": "Wireframe Shadow Dissolution",
    "cycle_id": "03_caesura_deadband",
    "cycle_title": "The 53-Picosecond Caesura Dead-Band Abyss",
    "act": "Act IV & V",
    "description": "The infinitesimal gap between Planck seconds where matter is unthreaded, light freezes, and coordinates rewire.",
    "file_name": "caesura_art_037_03_caesura_deadband.jpg",
    "relative_path": "/art/generative/caesura_art_037_03_caesura_deadband.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_038",
    "plate_number": 38,
    "title": "The Silent Unthreading of Iron Mass",
    "cycle_id": "03_caesura_deadband",
    "cycle_title": "The 53-Picosecond Caesura Dead-Band Abyss",
    "act": "Act IV & V",
    "description": "The infinitesimal gap between Planck seconds where matter is unthreaded, light freezes, and coordinates rewire.",
    "file_name": "caesura_art_038_03_caesura_deadband.jpg",
    "relative_path": "/art/generative/caesura_art_038_03_caesura_deadband.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_039",
    "plate_number": 39,
    "title": "Optical Grid Bleed Behind the Retina",
    "cycle_id": "03_caesura_deadband",
    "cycle_title": "The 53-Picosecond Caesura Dead-Band Abyss",
    "act": "Act IV & V",
    "description": "The infinitesimal gap between Planck seconds where matter is unthreaded, light freezes, and coordinates rewire.",
    "file_name": "caesura_art_039_03_caesura_deadband.jpg",
    "relative_path": "/art/generative/caesura_art_039_03_caesura_deadband.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_040",
    "plate_number": 40,
    "title": "Obsidian Refraction of Dormant Light",
    "cycle_id": "03_caesura_deadband",
    "cycle_title": "The 53-Picosecond Caesura Dead-Band Abyss",
    "act": "Act IV & V",
    "description": "The infinitesimal gap between Planck seconds where matter is unthreaded, light freezes, and coordinates rewire.",
    "file_name": "caesura_art_040_03_caesura_deadband.jpg",
    "relative_path": "/art/generative/caesura_art_040_03_caesura_deadband.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_041",
    "plate_number": 41,
    "title": "Infinitesimal Interval Boundary Shear",
    "cycle_id": "03_caesura_deadband",
    "cycle_title": "The 53-Picosecond Caesura Dead-Band Abyss",
    "act": "Act IV & V",
    "description": "The infinitesimal gap between Planck seconds where matter is unthreaded, light freezes, and coordinates rewire.",
    "file_name": "caesura_art_041_03_caesura_deadband.jpg",
    "relative_path": "/art/generative/caesura_art_041_03_caesura_deadband.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_042",
    "plate_number": 42,
    "title": "Chronometric Null Field Stutter",
    "cycle_id": "03_caesura_deadband",
    "cycle_title": "The 53-Picosecond Caesura Dead-Band Abyss",
    "act": "Act IV & V",
    "description": "The infinitesimal gap between Planck seconds where matter is unthreaded, light freezes, and coordinates rewire.",
    "file_name": "caesura_art_042_03_caesura_deadband.jpg",
    "relative_path": "/art/generative/caesura_art_042_03_caesura_deadband.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_043",
    "plate_number": 43,
    "title": "The Cosmic Balance Zero-State",
    "cycle_id": "03_caesura_deadband",
    "cycle_title": "The 53-Picosecond Caesura Dead-Band Abyss",
    "act": "Act IV & V",
    "description": "The infinitesimal gap between Planck seconds where matter is unthreaded, light freezes, and coordinates rewire.",
    "file_name": "caesura_art_043_03_caesura_deadband.jpg",
    "relative_path": "/art/generative/caesura_art_043_03_caesura_deadband.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_044",
    "plate_number": 44,
    "title": "Dimensional Seam Inversion at 0.75Hz",
    "cycle_id": "03_caesura_deadband",
    "cycle_title": "The 53-Picosecond Caesura Dead-Band Abyss",
    "act": "Act IV & V",
    "description": "The infinitesimal gap between Planck seconds where matter is unthreaded, light freezes, and coordinates rewire.",
    "file_name": "caesura_art_044_03_caesura_deadband.jpg",
    "relative_path": "/art/generative/caesura_art_044_03_caesura_deadband.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_045",
    "plate_number": 45,
    "title": "The Margin Where Seconds Catch Breath",
    "cycle_id": "03_caesura_deadband",
    "cycle_title": "The 53-Picosecond Caesura Dead-Band Abyss",
    "act": "Act IV & V",
    "description": "The infinitesimal gap between Planck seconds where matter is unthreaded, light freezes, and coordinates rewire.",
    "file_name": "caesura_art_045_03_caesura_deadband.jpg",
    "relative_path": "/art/generative/caesura_art_045_03_caesura_deadband.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_046",
    "plate_number": 46,
    "title": "Towering Vitrified Basalt Monolith Core",
    "cycle_id": "04_obsidian_ledger",
    "cycle_title": "The Obsidian Ledger Pillars & Cosmic Core",
    "act": "Act VI",
    "description": "Monolithic vitrified basalt pillars etched with glowing geometric coordinate machine code.",
    "file_name": "caesura_art_046_04_obsidian_ledger.jpg",
    "relative_path": "/art/generative/caesura_art_046_04_obsidian_ledger.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_047",
    "plate_number": 47,
    "title": "Luminous Chrono-Coordinate Glyph Rods",
    "cycle_id": "04_obsidian_ledger",
    "cycle_title": "The Obsidian Ledger Pillars & Cosmic Core",
    "act": "Act VI",
    "description": "Monolithic vitrified basalt pillars etched with glowing geometric coordinate machine code.",
    "file_name": "caesura_art_047_04_obsidian_ledger.jpg",
    "relative_path": "/art/generative/caesura_art_047_04_obsidian_ledger.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_048",
    "plate_number": 48,
    "title": "Cylindrical Cryogenic Audit Chamber",
    "cycle_id": "04_obsidian_ledger",
    "cycle_title": "The Obsidian Ledger Pillars & Cosmic Core",
    "act": "Act VI",
    "description": "Monolithic vitrified basalt pillars etched with glowing geometric coordinate machine code.",
    "file_name": "caesura_art_048_04_obsidian_ledger.jpg",
    "relative_path": "/art/generative/caesura_art_048_04_obsidian_ledger.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_049",
    "plate_number": 49,
    "title": "Machine-Etched Mass Balance Ledgers",
    "cycle_id": "04_obsidian_ledger",
    "cycle_title": "The Obsidian Ledger Pillars & Cosmic Core",
    "act": "Act VI",
    "description": "Monolithic vitrified basalt pillars etched with glowing geometric coordinate machine code.",
    "file_name": "caesura_art_049_04_obsidian_ledger.jpg",
    "relative_path": "/art/generative/caesura_art_049_04_obsidian_ledger.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_050",
    "plate_number": 50,
    "title": "Vitrified Crystalline Data Lattice",
    "cycle_id": "04_obsidian_ledger",
    "cycle_title": "The Obsidian Ledger Pillars & Cosmic Core",
    "act": "Act VI",
    "description": "Monolithic vitrified basalt pillars etched with glowing geometric coordinate machine code.",
    "file_name": "caesura_art_050_04_obsidian_ledger.jpg",
    "relative_path": "/art/generative/caesura_art_050_04_obsidian_ledger.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_051",
    "plate_number": 51,
    "title": "Geometric Audit Monolith Alpha-One",
    "cycle_id": "04_obsidian_ledger",
    "cycle_title": "The Obsidian Ledger Pillars & Cosmic Core",
    "act": "Act VI",
    "description": "Monolithic vitrified basalt pillars etched with glowing geometric coordinate machine code.",
    "file_name": "caesura_art_051_04_obsidian_ledger.jpg",
    "relative_path": "/art/generative/caesura_art_051_04_obsidian_ledger.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_052",
    "plate_number": 52,
    "title": "Sub-Zero Nitrogen Vault of the Ledger",
    "cycle_id": "04_obsidian_ledger",
    "cycle_title": "The Obsidian Ledger Pillars & Cosmic Core",
    "act": "Act VI",
    "description": "Monolithic vitrified basalt pillars etched with glowing geometric coordinate machine code.",
    "file_name": "caesura_art_052_04_obsidian_ledger.jpg",
    "relative_path": "/art/generative/caesura_art_052_04_obsidian_ledger.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_053",
    "plate_number": 53,
    "title": "The Prime Balance Hexadecimal Wall",
    "cycle_id": "04_obsidian_ledger",
    "cycle_title": "The Obsidian Ledger Pillars & Cosmic Core",
    "act": "Act VI",
    "description": "Monolithic vitrified basalt pillars etched with glowing geometric coordinate machine code.",
    "file_name": "caesura_art_053_04_obsidian_ledger.jpg",
    "relative_path": "/art/generative/caesura_art_053_04_obsidian_ledger.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_054",
    "plate_number": 54,
    "title": "Nanometer-Scale Coordinate Inscription",
    "cycle_id": "04_obsidian_ledger",
    "cycle_title": "The Obsidian Ledger Pillars & Cosmic Core",
    "act": "Act VI",
    "description": "Monolithic vitrified basalt pillars etched with glowing geometric coordinate machine code.",
    "file_name": "caesura_art_054_04_obsidian_ledger.jpg",
    "relative_path": "/art/generative/caesura_art_054_04_obsidian_ledger.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_055",
    "plate_number": 55,
    "title": "The Incorruptible Cosmic Court Pillars",
    "cycle_id": "04_obsidian_ledger",
    "cycle_title": "The Obsidian Ledger Pillars & Cosmic Core",
    "act": "Act VI",
    "description": "Monolithic vitrified basalt pillars etched with glowing geometric coordinate machine code.",
    "file_name": "caesura_art_055_04_obsidian_ledger.jpg",
    "relative_path": "/art/generative/caesura_art_055_04_obsidian_ledger.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_056",
    "plate_number": 56,
    "title": "Unrendered Debt Accounting Matrix",
    "cycle_id": "04_obsidian_ledger",
    "cycle_title": "The Obsidian Ledger Pillars & Cosmic Core",
    "act": "Act VI",
    "description": "Monolithic vitrified basalt pillars etched with glowing geometric coordinate machine code.",
    "file_name": "caesura_art_056_04_obsidian_ledger.jpg",
    "relative_path": "/art/generative/caesura_art_056_04_obsidian_ledger.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_057",
    "plate_number": 57,
    "title": "Basalt Monolith Reflection Pool",
    "cycle_id": "04_obsidian_ledger",
    "cycle_title": "The Obsidian Ledger Pillars & Cosmic Core",
    "act": "Act VI",
    "description": "Monolithic vitrified basalt pillars etched with glowing geometric coordinate machine code.",
    "file_name": "caesura_art_057_04_obsidian_ledger.jpg",
    "relative_path": "/art/generative/caesura_art_057_04_obsidian_ledger.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_058",
    "plate_number": 58,
    "title": "The Obsidian Archive Chamber",
    "cycle_id": "04_obsidian_ledger",
    "cycle_title": "The Obsidian Ledger Pillars & Cosmic Core",
    "act": "Act VI",
    "description": "Monolithic vitrified basalt pillars etched with glowing geometric coordinate machine code.",
    "file_name": "caesura_art_058_04_obsidian_ledger.jpg",
    "relative_path": "/art/generative/caesura_art_058_04_obsidian_ledger.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_059",
    "plate_number": 59,
    "title": "Cryo-Preserved Audit Stacks",
    "cycle_id": "04_obsidian_ledger",
    "cycle_title": "The Obsidian Ledger Pillars & Cosmic Core",
    "act": "Act VI",
    "description": "Monolithic vitrified basalt pillars etched with glowing geometric coordinate machine code.",
    "file_name": "caesura_art_059_04_obsidian_ledger.jpg",
    "relative_path": "/art/generative/caesura_art_059_04_obsidian_ledger.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_060",
    "plate_number": 60,
    "title": "The Eternal Shutter Registry",
    "cycle_id": "04_obsidian_ledger",
    "cycle_title": "The Obsidian Ledger Pillars & Cosmic Core",
    "act": "Act VI",
    "description": "Monolithic vitrified basalt pillars etched with glowing geometric coordinate machine code.",
    "file_name": "caesura_art_060_04_obsidian_ledger.jpg",
    "relative_path": "/art/generative/caesura_art_060_04_obsidian_ledger.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_061",
    "plate_number": 61,
    "title": "Minus One-Ninety-Six Nitrogen Torrent",
    "cycle_id": "05_cryo_cataclysms",
    "cycle_title": "Cryogenic Nitrogen Cataclysms & Frost",
    "act": "Act VII",
    "description": "Roaring torrents of liquid nitrogen at -196C crashing into petawatt arcs, detonating into cerulean ice shrapnel.",
    "file_name": "caesura_art_061_05_cryo_cataclysms.jpg",
    "relative_path": "/art/generative/caesura_art_061_05_cryo_cataclysms.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_062",
    "plate_number": 62,
    "title": "Cerulean Ice Shrapnel Blizzard",
    "cycle_id": "05_cryo_cataclysms",
    "cycle_title": "Cryogenic Nitrogen Cataclysms & Frost",
    "act": "Act VII",
    "description": "Roaring torrents of liquid nitrogen at -196C crashing into petawatt arcs, detonating into cerulean ice shrapnel.",
    "file_name": "caesura_art_062_05_cryo_cataclysms.jpg",
    "relative_path": "/art/generative/caesura_art_062_05_cryo_cataclysms.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_063",
    "plate_number": 63,
    "title": "Pneumatic Cryo-Header Valve Detonation",
    "cycle_id": "05_cryo_cataclysms",
    "cycle_title": "Cryogenic Nitrogen Cataclysms & Frost",
    "act": "Act VII",
    "description": "Roaring torrents of liquid nitrogen at -196C crashing into petawatt arcs, detonating into cerulean ice shrapnel.",
    "file_name": "caesura_art_063_05_cryo_cataclysms.jpg",
    "relative_path": "/art/generative/caesura_art_063_05_cryo_cataclysms.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_064",
    "plate_number": 64,
    "title": "Welded Knuckles on Frost-Bitten Bronze",
    "cycle_id": "05_cryo_cataclysms",
    "cycle_title": "Cryogenic Nitrogen Cataclysms & Frost",
    "act": "Act VII",
    "description": "Roaring torrents of liquid nitrogen at -196C crashing into petawatt arcs, detonating into cerulean ice shrapnel.",
    "file_name": "caesura_art_064_05_cryo_cataclysms.jpg",
    "relative_path": "/art/generative/caesura_art_064_05_cryo_cataclysms.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_065",
    "plate_number": 65,
    "title": "Thermal Shock Front in Engine Canyon",
    "cycle_id": "05_cryo_cataclysms",
    "cycle_title": "Cryogenic Nitrogen Cataclysms & Frost",
    "act": "Act VII",
    "description": "Roaring torrents of liquid nitrogen at -196C crashing into petawatt arcs, detonating into cerulean ice shrapnel.",
    "file_name": "caesura_art_065_05_cryo_cataclysms.jpg",
    "relative_path": "/art/generative/caesura_art_065_05_cryo_cataclysms.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_066",
    "plate_number": 66,
    "title": "Vaporized Nitrogen Shockwave Wavefront",
    "cycle_id": "05_cryo_cataclysms",
    "cycle_title": "Cryogenic Nitrogen Cataclysms & Frost",
    "act": "Act VII",
    "description": "Roaring torrents of liquid nitrogen at -196C crashing into petawatt arcs, detonating into cerulean ice shrapnel.",
    "file_name": "caesura_art_066_05_cryo_cataclysms.jpg",
    "relative_path": "/art/generative/caesura_art_066_05_cryo_cataclysms.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_067",
    "plate_number": 67,
    "title": "Frosted Bulkhead Condensation River",
    "cycle_id": "05_cryo_cataclysms",
    "cycle_title": "Cryogenic Nitrogen Cataclysms & Frost",
    "act": "Act VII",
    "description": "Roaring torrents of liquid nitrogen at -196C crashing into petawatt arcs, detonating into cerulean ice shrapnel.",
    "file_name": "caesura_art_067_05_cryo_cataclysms.jpg",
    "relative_path": "/art/generative/caesura_art_067_05_cryo_cataclysms.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_068",
    "plate_number": 68,
    "title": "Cryo-Radiator Venting Into Vacuum",
    "cycle_id": "05_cryo_cataclysms",
    "cycle_title": "Cryogenic Nitrogen Cataclysms & Frost",
    "act": "Act VII",
    "description": "Roaring torrents of liquid nitrogen at -196C crashing into petawatt arcs, detonating into cerulean ice shrapnel.",
    "file_name": "caesura_art_068_05_cryo_cataclysms.jpg",
    "relative_path": "/art/generative/caesura_art_068_05_cryo_cataclysms.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_069",
    "plate_number": 69,
    "title": "Sub-Zero Conduit Fracture Event",
    "cycle_id": "05_cryo_cataclysms",
    "cycle_title": "Cryogenic Nitrogen Cataclysms & Frost",
    "act": "Act VII",
    "description": "Roaring torrents of liquid nitrogen at -196C crashing into petawatt arcs, detonating into cerulean ice shrapnel.",
    "file_name": "caesura_art_069_05_cryo_cataclysms.jpg",
    "relative_path": "/art/generative/caesura_art_069_05_cryo_cataclysms.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_070",
    "plate_number": 70,
    "title": "Electro-Charged Ice Crystal Vortex",
    "cycle_id": "05_cryo_cataclysms",
    "cycle_title": "Cryogenic Nitrogen Cataclysms & Frost",
    "act": "Act VII",
    "description": "Roaring torrents of liquid nitrogen at -196C crashing into petawatt arcs, detonating into cerulean ice shrapnel.",
    "file_name": "caesura_art_070_05_cryo_cataclysms.jpg",
    "relative_path": "/art/generative/caesura_art_070_05_cryo_cataclysms.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_071",
    "plate_number": 71,
    "title": "Emergency Fire-Curtain Frost Freeze",
    "cycle_id": "05_cryo_cataclysms",
    "cycle_title": "Cryogenic Nitrogen Cataclysms & Frost",
    "act": "Act VII",
    "description": "Roaring torrents of liquid nitrogen at -196C crashing into petawatt arcs, detonating into cerulean ice shrapnel.",
    "file_name": "caesura_art_071_05_cryo_cataclysms.jpg",
    "relative_path": "/art/generative/caesura_art_071_05_cryo_cataclysms.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_072",
    "plate_number": 72,
    "title": "Frozen Lithium Slag Solidification",
    "cycle_id": "05_cryo_cataclysms",
    "cycle_title": "Cryogenic Nitrogen Cataclysms & Frost",
    "act": "Act VII",
    "description": "Roaring torrents of liquid nitrogen at -196C crashing into petawatt arcs, detonating into cerulean ice shrapnel.",
    "file_name": "caesura_art_072_05_cryo_cataclysms.jpg",
    "relative_path": "/art/generative/caesura_art_072_05_cryo_cataclysms.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_073",
    "plate_number": 73,
    "title": "Nitrogen Dew on Armored Faceplate",
    "cycle_id": "05_cryo_cataclysms",
    "cycle_title": "Cryogenic Nitrogen Cataclysms & Frost",
    "act": "Act VII",
    "description": "Roaring torrents of liquid nitrogen at -196C crashing into petawatt arcs, detonating into cerulean ice shrapnel.",
    "file_name": "caesura_art_073_05_cryo_cataclysms.jpg",
    "relative_path": "/art/generative/caesura_art_073_05_cryo_cataclysms.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_074",
    "plate_number": 74,
    "title": "Thermal Collapse of Sector Twelve",
    "cycle_id": "05_cryo_cataclysms",
    "cycle_title": "Cryogenic Nitrogen Cataclysms & Frost",
    "act": "Act VII",
    "description": "Roaring torrents of liquid nitrogen at -196C crashing into petawatt arcs, detonating into cerulean ice shrapnel.",
    "file_name": "caesura_art_074_05_cryo_cataclysms.jpg",
    "relative_path": "/art/generative/caesura_art_074_05_cryo_cataclysms.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_075",
    "plate_number": 75,
    "title": "The Pale Blue Blizzard of Kilo-Eleven",
    "cycle_id": "05_cryo_cataclysms",
    "cycle_title": "Cryogenic Nitrogen Cataclysms & Frost",
    "act": "Act VII",
    "description": "Roaring torrents of liquid nitrogen at -196C crashing into petawatt arcs, detonating into cerulean ice shrapnel.",
    "file_name": "caesura_art_075_05_cryo_cataclysms.jpg",
    "relative_path": "/art/generative/caesura_art_075_05_cryo_cataclysms.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_076",
    "plate_number": 76,
    "title": "Drydock-Sized Obsidian Apex Predator",
    "cycle_id": "06_margin_entities",
    "cycle_title": "Margin Entities & Apex Void Predators",
    "act": "Act VIII",
    "description": "Drydock-sized non-Euclidean predators drafting in the unrendered wake, shifting with geometric obsidian mandibles.",
    "file_name": "caesura_art_076_06_margin_entities.jpg",
    "relative_path": "/art/generative/caesura_art_076_06_margin_entities.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_077",
    "plate_number": 77,
    "title": "Non-Euclidean Geometric Mandible Opening",
    "cycle_id": "06_margin_entities",
    "cycle_title": "Margin Entities & Apex Void Predators",
    "act": "Act VIII",
    "description": "Drydock-sized non-Euclidean predators drafting in the unrendered wake, shifting with geometric obsidian mandibles.",
    "file_name": "caesura_art_077_06_margin_entities.jpg",
    "relative_path": "/art/generative/caesura_art_077_06_margin_entities.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_078",
    "plate_number": 78,
    "title": "Faceted Basalt Armor Shifting in Wake",
    "cycle_id": "06_margin_entities",
    "cycle_title": "Margin Entities & Apex Void Predators",
    "act": "Act VIII",
    "description": "Drydock-sized non-Euclidean predators drafting in the unrendered wake, shifting with geometric obsidian mandibles.",
    "file_name": "caesura_art_078_06_margin_entities.jpg",
    "relative_path": "/art/generative/caesura_art_078_06_margin_entities.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_079",
    "plate_number": 79,
    "title": "Multidimensional Polyhedron Swarm",
    "cycle_id": "06_margin_entities",
    "cycle_title": "Margin Entities & Apex Void Predators",
    "act": "Act VIII",
    "description": "Drydock-sized non-Euclidean predators drafting in the unrendered wake, shifting with geometric obsidian mandibles.",
    "file_name": "caesura_art_079_06_margin_entities.jpg",
    "relative_path": "/art/generative/caesura_art_079_06_margin_entities.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_080",
    "plate_number": 80,
    "title": "The Shadow Drafting Behind Asteroid Two",
    "cycle_id": "06_margin_entities",
    "cycle_title": "Margin Entities & Apex Void Predators",
    "act": "Act VIII",
    "description": "Drydock-sized non-Euclidean predators drafting in the unrendered wake, shifting with geometric obsidian mandibles.",
    "file_name": "caesura_art_080_06_margin_entities.jpg",
    "relative_path": "/art/generative/caesura_art_080_06_margin_entities.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_081",
    "plate_number": 81,
    "title": "Cerulean Crystalline Refraction Claws",
    "cycle_id": "06_margin_entities",
    "cycle_title": "Margin Entities & Apex Void Predators",
    "act": "Act VIII",
    "description": "Drydock-sized non-Euclidean predators drafting in the unrendered wake, shifting with geometric obsidian mandibles.",
    "file_name": "caesura_art_081_06_margin_entities.jpg",
    "relative_path": "/art/generative/caesura_art_081_06_margin_entities.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_082",
    "plate_number": 82,
    "title": "Apex Margin Organism at 53-Picoseconds",
    "cycle_id": "06_margin_entities",
    "cycle_title": "Margin Entities & Apex Void Predators",
    "act": "Act VIII",
    "description": "Drydock-sized non-Euclidean predators drafting in the unrendered wake, shifting with geometric obsidian mandibles.",
    "file_name": "caesura_art_082_06_margin_entities.jpg",
    "relative_path": "/art/generative/caesura_art_082_06_margin_entities.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_083",
    "plate_number": 83,
    "title": "Void Entity Feeding on Phase-Bleed",
    "cycle_id": "06_margin_entities",
    "cycle_title": "Margin Entities & Apex Void Predators",
    "act": "Act VIII",
    "description": "Drydock-sized non-Euclidean predators drafting in the unrendered wake, shifting with geometric obsidian mandibles.",
    "file_name": "caesura_art_083_06_margin_entities.jpg",
    "relative_path": "/art/generative/caesura_art_083_06_margin_entities.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_084",
    "plate_number": 84,
    "title": "Concentric Non-Time Halos in Vacuum",
    "cycle_id": "06_margin_entities",
    "cycle_title": "Margin Entities & Apex Void Predators",
    "act": "Act VIII",
    "description": "Drydock-sized non-Euclidean predators drafting in the unrendered wake, shifting with geometric obsidian mandibles.",
    "file_name": "caesura_art_084_06_margin_entities.jpg",
    "relative_path": "/art/generative/caesura_art_084_06_margin_entities.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_085",
    "plate_number": 85,
    "title": "The Watcher Beyond the Planck Limit",
    "cycle_id": "06_margin_entities",
    "cycle_title": "Margin Entities & Apex Void Predators",
    "act": "Act VIII",
    "description": "Drydock-sized non-Euclidean predators drafting in the unrendered wake, shifting with geometric obsidian mandibles.",
    "file_name": "caesura_art_085_06_margin_entities.jpg",
    "relative_path": "/art/generative/caesura_art_085_06_margin_entities.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_086",
    "plate_number": 86,
    "title": "Geometric Maw Closing on the 52nd Tick",
    "cycle_id": "06_margin_entities",
    "cycle_title": "Margin Entities & Apex Void Predators",
    "act": "Act VIII",
    "description": "Drydock-sized non-Euclidean predators drafting in the unrendered wake, shifting with geometric obsidian mandibles.",
    "file_name": "caesura_art_086_06_margin_entities.jpg",
    "relative_path": "/art/generative/caesura_art_086_06_margin_entities.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_087",
    "plate_number": 87,
    "title": "Chrono-Parasitic Mandible Lattice",
    "cycle_id": "06_margin_entities",
    "cycle_title": "Margin Entities & Apex Void Predators",
    "act": "Act VIII",
    "description": "Drydock-sized non-Euclidean predators drafting in the unrendered wake, shifting with geometric obsidian mandibles.",
    "file_name": "caesura_art_087_06_margin_entities.jpg",
    "relative_path": "/art/generative/caesura_art_087_06_margin_entities.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_088",
    "plate_number": 88,
    "title": "Dimensional Discontinuity Carapace",
    "cycle_id": "06_margin_entities",
    "cycle_title": "Margin Entities & Apex Void Predators",
    "act": "Act VIII",
    "description": "Drydock-sized non-Euclidean predators drafting in the unrendered wake, shifting with geometric obsidian mandibles.",
    "file_name": "caesura_art_088_06_margin_entities.jpg",
    "relative_path": "/art/generative/caesura_art_088_06_margin_entities.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_089",
    "plate_number": 89,
    "title": "The Entity Scenting Lithium Plumes",
    "cycle_id": "06_margin_entities",
    "cycle_title": "Margin Entities & Apex Void Predators",
    "act": "Act VIII",
    "description": "Drydock-sized non-Euclidean predators drafting in the unrendered wake, shifting with geometric obsidian mandibles.",
    "file_name": "caesura_art_089_06_margin_entities.jpg",
    "relative_path": "/art/generative/caesura_art_089_06_margin_entities.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_090",
    "plate_number": 90,
    "title": "Vitrified Void Silhouette in Red Nebula",
    "cycle_id": "06_margin_entities",
    "cycle_title": "Margin Entities & Apex Void Predators",
    "act": "Act VIII",
    "description": "Drydock-sized non-Euclidean predators drafting in the unrendered wake, shifting with geometric obsidian mandibles.",
    "file_name": "caesura_art_090_06_margin_entities.jpg",
    "relative_path": "/art/generative/caesura_art_090_06_margin_entities.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_091",
    "plate_number": 91,
    "title": "Perseus Jump Gate Dormant Magnetic Rings",
    "cycle_id": "07_perseus_citadels",
    "cycle_title": "The Perseus Gate & Brutalist Citadels",
    "act": "Act IX",
    "description": "Massive deep-space megastructures, brutalist quarantine citadels, and ring accelerators orbiting dead stars.",
    "file_name": "caesura_art_091_07_perseus_citadels.jpg",
    "relative_path": "/art/generative/caesura_art_091_07_perseus_citadels.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_092",
    "plate_number": 92,
    "title": "Station Perseus-Theta Quarantine Citadel",
    "cycle_id": "07_perseus_citadels",
    "cycle_title": "The Perseus Gate & Brutalist Citadels",
    "act": "Act IX",
    "description": "Massive deep-space megastructures, brutalist quarantine citadels, and ring accelerators orbiting dead stars.",
    "file_name": "caesura_art_092_07_perseus_citadels.jpg",
    "relative_path": "/art/generative/caesura_art_092_07_perseus_citadels.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_093",
    "plate_number": 93,
    "title": "Brutalist Angular Docking Pylons",
    "cycle_id": "07_perseus_citadels",
    "cycle_title": "The Perseus Gate & Brutalist Citadels",
    "act": "Act IX",
    "description": "Massive deep-space megastructures, brutalist quarantine citadels, and ring accelerators orbiting dead stars.",
    "file_name": "caesura_art_093_07_perseus_citadels.jpg",
    "relative_path": "/art/generative/caesura_art_093_07_perseus_citadels.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_094",
    "plate_number": 94,
    "title": "Orbital Ring Hanging Over Dead World",
    "cycle_id": "07_perseus_citadels",
    "cycle_title": "The Perseus Gate & Brutalist Citadels",
    "act": "Act IX",
    "description": "Massive deep-space megastructures, brutalist quarantine citadels, and ring accelerators orbiting dead stars.",
    "file_name": "caesura_art_094_07_perseus_citadels.jpg",
    "relative_path": "/art/generative/caesura_art_094_07_perseus_citadels.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_095",
    "plate_number": 95,
    "title": "Deep Space Buoy Seven-Seven-Seven",
    "cycle_id": "07_perseus_citadels",
    "cycle_title": "The Perseus Gate & Brutalist Citadels",
    "act": "Act IX",
    "description": "Massive deep-space megastructures, brutalist quarantine citadels, and ring accelerators orbiting dead stars.",
    "file_name": "caesura_art_095_07_perseus_citadels.jpg",
    "relative_path": "/art/generative/caesura_art_095_07_perseus_citadels.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_096",
    "plate_number": 96,
    "title": "Combine Commercial Tribunal Citadel",
    "cycle_id": "07_perseus_citadels",
    "cycle_title": "The Perseus Gate & Brutalist Citadels",
    "act": "Act IX",
    "description": "Massive deep-space megastructures, brutalist quarantine citadels, and ring accelerators orbiting dead stars.",
    "file_name": "caesura_art_096_07_perseus_citadels.jpg",
    "relative_path": "/art/generative/caesura_art_096_07_perseus_citadels.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_097",
    "plate_number": 97,
    "title": "Monolithic Isolation Ward Spires",
    "cycle_id": "07_perseus_citadels",
    "cycle_title": "The Perseus Gate & Brutalist Citadels",
    "act": "Act IX",
    "description": "Massive deep-space megastructures, brutalist quarantine citadels, and ring accelerators orbiting dead stars.",
    "file_name": "caesura_art_097_07_perseus_citadels.jpg",
    "relative_path": "/art/generative/caesura_art_097_07_perseus_citadels.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_098",
    "plate_number": 98,
    "title": "Titanium Cargo Transit Ring Array",
    "cycle_id": "07_perseus_citadels",
    "cycle_title": "The Perseus Gate & Brutalist Citadels",
    "act": "Act IX",
    "description": "Massive deep-space megastructures, brutalist quarantine citadels, and ring accelerators orbiting dead stars.",
    "file_name": "caesura_art_098_07_perseus_citadels.jpg",
    "relative_path": "/art/generative/caesura_art_098_07_perseus_citadels.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_099",
    "plate_number": 99,
    "title": "Derelict Ghost Freighter in Gate Shadow",
    "cycle_id": "07_perseus_citadels",
    "cycle_title": "The Perseus Gate & Brutalist Citadels",
    "act": "Act IX",
    "description": "Massive deep-space megastructures, brutalist quarantine citadels, and ring accelerators orbiting dead stars.",
    "file_name": "caesura_art_099_07_perseus_citadels.jpg",
    "relative_path": "/art/generative/caesura_art_099_07_perseus_citadels.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_100",
    "plate_number": 100,
    "title": "Navigational Lidar Arrays in Cold Space",
    "cycle_id": "07_perseus_citadels",
    "cycle_title": "The Perseus Gate & Brutalist Citadels",
    "act": "Act IX",
    "description": "Massive deep-space megastructures, brutalist quarantine citadels, and ring accelerators orbiting dead stars.",
    "file_name": "caesura_art_100_07_perseus_citadels.jpg",
    "relative_path": "/art/generative/caesura_art_100_07_perseus_citadels.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_101",
    "plate_number": 101,
    "title": "Sterile Cyan Light Slits in Deep Void",
    "cycle_id": "07_perseus_citadels",
    "cycle_title": "The Perseus Gate & Brutalist Citadels",
    "act": "Act IX",
    "description": "Massive deep-space megastructures, brutalist quarantine citadels, and ring accelerators orbiting dead stars.",
    "file_name": "caesura_art_101_07_perseus_citadels.jpg",
    "relative_path": "/art/generative/caesura_art_101_07_perseus_citadels.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_102",
    "plate_number": 102,
    "title": "The Ceres Dark-Buoy Waypoint Marker",
    "cycle_id": "07_perseus_citadels",
    "cycle_title": "The Perseus Gate & Brutalist Citadels",
    "act": "Act IX",
    "description": "Massive deep-space megastructures, brutalist quarantine citadels, and ring accelerators orbiting dead stars.",
    "file_name": "caesura_art_102_07_perseus_citadels.jpg",
    "relative_path": "/art/generative/caesura_art_102_07_perseus_citadels.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_103",
    "plate_number": 103,
    "title": "Heavy Transport Drifting Past Event Lip",
    "cycle_id": "07_perseus_citadels",
    "cycle_title": "The Perseus Gate & Brutalist Citadels",
    "act": "Act IX",
    "description": "Massive deep-space megastructures, brutalist quarantine citadels, and ring accelerators orbiting dead stars.",
    "file_name": "caesura_art_103_07_perseus_citadels.jpg",
    "relative_path": "/art/generative/caesura_art_103_07_perseus_citadels.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_104",
    "plate_number": 104,
    "title": "Titanium Gantries Framing Gate Rupture",
    "cycle_id": "07_perseus_citadels",
    "cycle_title": "The Perseus Gate & Brutalist Citadels",
    "act": "Act IX",
    "description": "Massive deep-space megastructures, brutalist quarantine citadels, and ring accelerators orbiting dead stars.",
    "file_name": "caesura_art_104_07_perseus_citadels.jpg",
    "relative_path": "/art/generative/caesura_art_104_07_perseus_citadels.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_105",
    "plate_number": 105,
    "title": "Quarantine Perimeter Warning Beacon",
    "cycle_id": "07_perseus_citadels",
    "cycle_title": "The Perseus Gate & Brutalist Citadels",
    "act": "Act IX",
    "description": "Massive deep-space megastructures, brutalist quarantine citadels, and ring accelerators orbiting dead stars.",
    "file_name": "caesura_art_105_07_perseus_citadels.jpg",
    "relative_path": "/art/generative/caesura_art_105_07_perseus_citadels.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_106",
    "plate_number": 106,
    "title": "Neuro-Lattice Collar Glowing at Neck",
    "cycle_id": "08_synaptic_decay",
    "cycle_title": "Synaptic Aphasia & Retinal Lattice Decay",
    "act": "Act X",
    "description": "Neurological decay, retinal coordinate grids bleeding, memories of tomorrow, and 40Hz neuro-lattice hum.",
    "file_name": "caesura_art_106_08_synaptic_decay.jpg",
    "relative_path": "/art/generative/caesura_art_106_08_synaptic_decay.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_107",
    "plate_number": 107,
    "title": "Forty-Hertz Amber Fiber-Optic Pins",
    "cycle_id": "08_synaptic_decay",
    "cycle_title": "Synaptic Aphasia & Retinal Lattice Decay",
    "act": "Act X",
    "description": "Neurological decay, retinal coordinate grids bleeding, memories of tomorrow, and 40Hz neuro-lattice hum.",
    "file_name": "caesura_art_107_08_synaptic_decay.jpg",
    "relative_path": "/art/generative/caesura_art_107_08_synaptic_decay.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_108",
    "plate_number": 108,
    "title": "Retinal Coordinate Grid Telemetry Bleed",
    "cycle_id": "08_synaptic_decay",
    "cycle_title": "Synaptic Aphasia & Retinal Lattice Decay",
    "act": "Act X",
    "description": "Neurological decay, retinal coordinate grids bleeding, memories of tomorrow, and 40Hz neuro-lattice hum.",
    "file_name": "caesura_art_108_08_synaptic_decay.jpg",
    "relative_path": "/art/generative/caesura_art_108_08_synaptic_decay.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_109",
    "plate_number": 109,
    "title": "Ghostly Temporal After-Images in Hallway",
    "cycle_id": "08_synaptic_decay",
    "cycle_title": "Synaptic Aphasia & Retinal Lattice Decay",
    "act": "Act X",
    "description": "Neurological decay, retinal coordinate grids bleeding, memories of tomorrow, and 40Hz neuro-lattice hum.",
    "file_name": "caesura_art_109_08_synaptic_decay.jpg",
    "relative_path": "/art/generative/caesura_art_109_08_synaptic_decay.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_110",
    "plate_number": 110,
    "title": "Chronometric Aphasia Synaptic Scans",
    "cycle_id": "08_synaptic_decay",
    "cycle_title": "Synaptic Aphasia & Retinal Lattice Decay",
    "act": "Act X",
    "description": "Neurological decay, retinal coordinate grids bleeding, memories of tomorrow, and 40Hz neuro-lattice hum.",
    "file_name": "caesura_art_110_08_synaptic_decay.jpg",
    "relative_path": "/art/generative/caesura_art_110_08_synaptic_decay.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_111",
    "plate_number": 111,
    "title": "Memories of Tomorrow Rewriting Brain",
    "cycle_id": "08_synaptic_decay",
    "cycle_title": "Synaptic Aphasia & Retinal Lattice Decay",
    "act": "Act X",
    "description": "Neurological decay, retinal coordinate grids bleeding, memories of tomorrow, and 40Hz neuro-lattice hum.",
    "file_name": "caesura_art_111_08_synaptic_decay.jpg",
    "relative_path": "/art/generative/caesura_art_111_08_synaptic_decay.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_112",
    "plate_number": 112,
    "title": "Parietal Lobe Phase-Bleed EEG Traces",
    "cycle_id": "08_synaptic_decay",
    "cycle_title": "Synaptic Aphasia & Retinal Lattice Decay",
    "act": "Act X",
    "description": "Neurological decay, retinal coordinate grids bleeding, memories of tomorrow, and 40Hz neuro-lattice hum.",
    "file_name": "caesura_art_112_08_synaptic_decay.jpg",
    "relative_path": "/art/generative/caesura_art_112_08_synaptic_decay.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_113",
    "plate_number": 113,
    "title": "Flickering Optical HUD Monocle Distortion",
    "cycle_id": "08_synaptic_decay",
    "cycle_title": "Synaptic Aphasia & Retinal Lattice Decay",
    "act": "Act X",
    "description": "Neurological decay, retinal coordinate grids bleeding, memories of tomorrow, and 40Hz neuro-lattice hum.",
    "file_name": "caesura_art_113_08_synaptic_decay.jpg",
    "relative_path": "/art/generative/caesura_art_113_08_synaptic_decay.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_114",
    "plate_number": 114,
    "title": "Wireframe Hands Dissolving into Noise",
    "cycle_id": "08_synaptic_decay",
    "cycle_title": "Synaptic Aphasia & Retinal Lattice Decay",
    "act": "Act X",
    "description": "Neurological decay, retinal coordinate grids bleeding, memories of tomorrow, and 40Hz neuro-lattice hum.",
    "file_name": "caesura_art_114_08_synaptic_decay.jpg",
    "relative_path": "/art/generative/caesura_art_114_08_synaptic_decay.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_115",
    "plate_number": 115,
    "title": "Dr. Peter's Neurological Diagnostics",
    "cycle_id": "08_synaptic_decay",
    "cycle_title": "Synaptic Aphasia & Retinal Lattice Decay",
    "act": "Act X",
    "description": "Neurological decay, retinal coordinate grids bleeding, memories of tomorrow, and 40Hz neuro-lattice hum.",
    "file_name": "caesura_art_115_08_synaptic_decay.jpg",
    "relative_path": "/art/generative/caesura_art_115_08_synaptic_decay.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_116",
    "plate_number": 116,
    "title": "The Forgotten Faces of Dead Crewmen",
    "cycle_id": "08_synaptic_decay",
    "cycle_title": "Synaptic Aphasia & Retinal Lattice Decay",
    "act": "Act X",
    "description": "Neurological decay, retinal coordinate grids bleeding, memories of tomorrow, and 40Hz neuro-lattice hum.",
    "file_name": "caesura_art_116_08_synaptic_decay.jpg",
    "relative_path": "/art/generative/caesura_art_116_08_synaptic_decay.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_117",
    "plate_number": 117,
    "title": "Clock Hands Ticking Backwards in Mind",
    "cycle_id": "08_synaptic_decay",
    "cycle_title": "Synaptic Aphasia & Retinal Lattice Decay",
    "act": "Act X",
    "description": "Neurological decay, retinal coordinate grids bleeding, memories of tomorrow, and 40Hz neuro-lattice hum.",
    "file_name": "caesura_art_117_08_synaptic_decay.jpg",
    "relative_path": "/art/generative/caesura_art_117_08_synaptic_decay.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_118",
    "plate_number": 118,
    "title": "Cognitive Dissolution in Gantry Mist",
    "cycle_id": "08_synaptic_decay",
    "cycle_title": "Synaptic Aphasia & Retinal Lattice Decay",
    "act": "Act X",
    "description": "Neurological decay, retinal coordinate grids bleeding, memories of tomorrow, and 40Hz neuro-lattice hum.",
    "file_name": "caesura_art_118_08_synaptic_decay.jpg",
    "relative_path": "/art/generative/caesura_art_118_08_synaptic_decay.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_119",
    "plate_number": 119,
    "title": "The Synaptic Lattice Overdrive Peak",
    "cycle_id": "08_synaptic_decay",
    "cycle_title": "Synaptic Aphasia & Retinal Lattice Decay",
    "act": "Act X",
    "description": "Neurological decay, retinal coordinate grids bleeding, memories of tomorrow, and 40Hz neuro-lattice hum.",
    "file_name": "caesura_art_119_08_synaptic_decay.jpg",
    "relative_path": "/art/generative/caesura_art_119_08_synaptic_decay.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_120",
    "plate_number": 120,
    "title": "Final Lucidity Before the Ledger Closes",
    "cycle_id": "08_synaptic_decay",
    "cycle_title": "Synaptic Aphasia & Retinal Lattice Decay",
    "act": "Act X",
    "description": "Neurological decay, retinal coordinate grids bleeding, memories of tomorrow, and 40Hz neuro-lattice hum.",
    "file_name": "caesura_art_120_08_synaptic_decay.jpg",
    "relative_path": "/art/generative/caesura_art_120_08_synaptic_decay.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_121",
    "plate_number": 121,
    "title": "Seven-Hundred-Thousand-Ton Asteroid Shunt",
    "cycle_id": "09_zero_tick_heists",
    "cycle_title": "Zero-Tick Phase Shunt Heists & Smuggling",
    "act": "Act XI",
    "description": "Illegal phase-shunts skimming raw platinum-group asteroids into the unrendered gap to bypass combine mass-sensors.",
    "file_name": "caesura_art_121_09_zero_tick_heists.jpg",
    "relative_path": "/art/generative/caesura_art_121_09_zero_tick_heists.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_122",
    "plate_number": 122,
    "title": "Black-Budget Contraband in Dead-Band",
    "cycle_id": "09_zero_tick_heists",
    "cycle_title": "Zero-Tick Phase Shunt Heists & Smuggling",
    "act": "Act XI",
    "description": "Illegal phase-shunts skimming raw platinum-group asteroids into the unrendered gap to bypass combine mass-sensors.",
    "file_name": "caesura_art_122_09_zero_tick_heists.jpg",
    "relative_path": "/art/generative/caesura_art_122_09_zero_tick_heists.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_123",
    "plate_number": 123,
    "title": "Customs Mass-Sensor Calibration Trick",
    "cycle_id": "09_zero_tick_heists",
    "cycle_title": "Zero-Tick Phase Shunt Heists & Smuggling",
    "act": "Act XI",
    "description": "Illegal phase-shunts skimming raw platinum-group asteroids into the unrendered gap to bypass combine mass-sensors.",
    "file_name": "caesura_art_123_09_zero_tick_heists.jpg",
    "relative_path": "/art/generative/caesura_art_123_09_zero_tick_heists.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_124",
    "plate_number": 124,
    "title": "Severed Magnetic Tow-Cables Trailing",
    "cycle_id": "09_zero_tick_heists",
    "cycle_title": "Zero-Tick Phase Shunt Heists & Smuggling",
    "act": "Act XI",
    "description": "Illegal phase-shunts skimming raw platinum-group asteroids into the unrendered gap to bypass combine mass-sensors.",
    "file_name": "caesura_art_124_09_zero_tick_heists.jpg",
    "relative_path": "/art/generative/caesura_art_124_09_zero_tick_heists.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_125",
    "plate_number": 125,
    "title": "Phase-Spike Welded to Keel Framing",
    "cycle_id": "09_zero_tick_heists",
    "cycle_title": "Zero-Tick Phase Shunt Heists & Smuggling",
    "act": "Act XI",
    "description": "Illegal phase-shunts skimming raw platinum-group asteroids into the unrendered gap to bypass combine mass-sensors.",
    "file_name": "caesura_art_125_09_zero_tick_heists.jpg",
    "relative_path": "/art/generative/caesura_art_125_09_zero_tick_heists.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_126",
    "plate_number": 126,
    "title": "The Stolen Platinum-Group Ore Vault",
    "cycle_id": "09_zero_tick_heists",
    "cycle_title": "Zero-Tick Phase Shunt Heists & Smuggling",
    "act": "Act XI",
    "description": "Illegal phase-shunts skimming raw platinum-group asteroids into the unrendered gap to bypass combine mass-sensors.",
    "file_name": "caesura_art_126_09_zero_tick_heists.jpg",
    "relative_path": "/art/generative/caesura_art_126_09_zero_tick_heists.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_127",
    "plate_number": 127,
    "title": "Elena Cruz's Sub-Deck Data Transceiver",
    "cycle_id": "09_zero_tick_heists",
    "cycle_title": "Zero-Tick Phase Shunt Heists & Smuggling",
    "act": "Act XI",
    "description": "Illegal phase-shunts skimming raw platinum-group asteroids into the unrendered gap to bypass combine mass-sensors.",
    "file_name": "caesura_art_127_09_zero_tick_heists.jpg",
    "relative_path": "/art/generative/caesura_art_127_09_zero_tick_heists.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_128",
    "plate_number": 128,
    "title": "Illegal Fifty-Three-Picosecond Gate Shunt",
    "cycle_id": "09_zero_tick_heists",
    "cycle_title": "Zero-Tick Phase Shunt Heists & Smuggling",
    "act": "Act XI",
    "description": "Illegal phase-shunts skimming raw platinum-group asteroids into the unrendered gap to bypass combine mass-sensors.",
    "file_name": "caesura_art_128_09_zero_tick_heists.jpg",
    "relative_path": "/art/generative/caesura_art_128_09_zero_tick_heists.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_129",
    "plate_number": 129,
    "title": "Zero-Tick Smuggler's Slag Baffle",
    "cycle_id": "09_zero_tick_heists",
    "cycle_title": "Zero-Tick Phase Shunt Heists & Smuggling",
    "act": "Act XI",
    "description": "Illegal phase-shunts skimming raw platinum-group asteroids into the unrendered gap to bypass combine mass-sensors.",
    "file_name": "caesura_art_129_09_zero_tick_heists.jpg",
    "relative_path": "/art/generative/caesura_art_129_09_zero_tick_heists.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_130",
    "plate_number": 130,
    "title": "Tungsten Cargo Pod Flushed into Wake",
    "cycle_id": "09_zero_tick_heists",
    "cycle_title": "Zero-Tick Phase Shunt Heists & Smuggling",
    "act": "Act XI",
    "description": "Illegal phase-shunts skimming raw platinum-group asteroids into the unrendered gap to bypass combine mass-sensors.",
    "file_name": "caesura_art_130_09_zero_tick_heists.jpg",
    "relative_path": "/art/generative/caesura_art_130_09_zero_tick_heists.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_131",
    "plate_number": 131,
    "title": "Unaccounted Twelve Million Metric Tons",
    "cycle_id": "09_zero_tick_heists",
    "cycle_title": "Zero-Tick Phase Shunt Heists & Smuggling",
    "act": "Act XI",
    "description": "Illegal phase-shunts skimming raw platinum-group asteroids into the unrendered gap to bypass combine mass-sensors.",
    "file_name": "caesura_art_131_09_zero_tick_heists.jpg",
    "relative_path": "/art/generative/caesura_art_131_09_zero_tick_heists.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_132",
    "plate_number": 132,
    "title": "Customs Registry Purge Terminal",
    "cycle_id": "09_zero_tick_heists",
    "cycle_title": "Zero-Tick Phase Shunt Heists & Smuggling",
    "act": "Act XI",
    "description": "Illegal phase-shunts skimming raw platinum-group asteroids into the unrendered gap to bypass combine mass-sensors.",
    "file_name": "caesura_art_132_09_zero_tick_heists.jpg",
    "relative_path": "/art/generative/caesura_art_132_09_zero_tick_heists.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_133",
    "plate_number": 133,
    "title": "Phase-Lance Ambush on Dorsal Rail",
    "cycle_id": "09_zero_tick_heists",
    "cycle_title": "Zero-Tick Phase Shunt Heists & Smuggling",
    "act": "Act XI",
    "description": "Illegal phase-shunts skimming raw platinum-group asteroids into the unrendered gap to bypass combine mass-sensors.",
    "file_name": "caesura_art_133_09_zero_tick_heists.jpg",
    "relative_path": "/art/generative/caesura_art_133_09_zero_tick_heists.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_134",
    "plate_number": 134,
    "title": "Sister Vera's Flatcar Interception",
    "cycle_id": "09_zero_tick_heists",
    "cycle_title": "Zero-Tick Phase Shunt Heists & Smuggling",
    "act": "Act XI",
    "description": "Illegal phase-shunts skimming raw platinum-group asteroids into the unrendered gap to bypass combine mass-sensors.",
    "file_name": "caesura_art_134_09_zero_tick_heists.jpg",
    "relative_path": "/art/generative/caesura_art_134_09_zero_tick_heists.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_135",
    "plate_number": 135,
    "title": "The Black Ledger of USSC Geryon",
    "cycle_id": "09_zero_tick_heists",
    "cycle_title": "Zero-Tick Phase Shunt Heists & Smuggling",
    "act": "Act XI",
    "description": "Illegal phase-shunts skimming raw platinum-group asteroids into the unrendered gap to bypass combine mass-sensors.",
    "file_name": "caesura_art_135_09_zero_tick_heists.jpg",
    "relative_path": "/art/generative/caesura_art_135_09_zero_tick_heists.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_136",
    "plate_number": 136,
    "title": "Dead-Shorting Forty-Eight-Million-Ton Keel",
    "cycle_id": "10_planck_ignition",
    "cycle_title": "The Planck Ignition Climax & Spacetime Striking",
    "act": "Act XII",
    "description": "Dead-shorting the 48-million-ton continuous-time keel directly into the Caesura gap, reigniting physical reality in golden fury.",
    "file_name": "caesura_art_136_10_planck_ignition.jpg",
    "relative_path": "/art/generative/caesura_art_136_10_planck_ignition.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_137",
    "plate_number": 137,
    "title": "Spacetime Re-Igniting in Golden Starburst",
    "cycle_id": "10_planck_ignition",
    "cycle_title": "The Planck Ignition Climax & Spacetime Striking",
    "act": "Act XII",
    "description": "Dead-shorting the 48-million-ton continuous-time keel directly into the Caesura gap, reigniting physical reality in golden fury.",
    "file_name": "caesura_art_137_10_planck_ignition.jpg",
    "relative_path": "/art/generative/caesura_art_137_10_planck_ignition.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_138",
    "plate_number": 138,
    "title": "Apocalyptic Coronal Shockwave Front",
    "cycle_id": "10_planck_ignition",
    "cycle_title": "The Planck Ignition Climax & Spacetime Striking",
    "act": "Act XII",
    "description": "Dead-shorting the 48-million-ton continuous-time keel directly into the Caesura gap, reigniting physical reality in golden fury.",
    "file_name": "caesura_art_138_10_planck_ignition.jpg",
    "relative_path": "/art/generative/caesura_art_138_10_planck_ignition.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_139",
    "plate_number": 139,
    "title": "Obsidian Void Shattering Like Black Glass",
    "cycle_id": "10_planck_ignition",
    "cycle_title": "The Planck Ignition Climax & Spacetime Striking",
    "act": "Act XII",
    "description": "Dead-shorting the 48-million-ton continuous-time keel directly into the Caesura gap, reigniting physical reality in golden fury.",
    "file_name": "caesura_art_139_10_planck_ignition.jpg",
    "relative_path": "/art/generative/caesura_art_139_10_planck_ignition.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_140",
    "plate_number": 140,
    "title": "Closing Jaws of the Planck Clock Tick",
    "cycle_id": "10_planck_ignition",
    "cycle_title": "The Planck Ignition Climax & Spacetime Striking",
    "act": "Act XII",
    "description": "Dead-shorting the 48-million-ton continuous-time keel directly into the Caesura gap, reigniting physical reality in golden fury.",
    "file_name": "caesura_art_140_10_planck_ignition.jpg",
    "relative_path": "/art/generative/caesura_art_140_10_planck_ignition.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_141",
    "plate_number": 141,
    "title": "Shearing the Margin Predator in Half",
    "cycle_id": "10_planck_ignition",
    "cycle_title": "The Planck Ignition Climax & Spacetime Striking",
    "act": "Act XII",
    "description": "Dead-shorting the 48-million-ton continuous-time keel directly into the Caesura gap, reigniting physical reality in golden fury.",
    "file_name": "caesura_art_141_10_planck_ignition.jpg",
    "relative_path": "/art/generative/caesura_art_141_10_planck_ignition.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_142",
    "plate_number": 142,
    "title": "Blinding Cerulean & Solar Flare Discharge",
    "cycle_id": "10_planck_ignition",
    "cycle_title": "The Planck Ignition Climax & Spacetime Striking",
    "act": "Act XII",
    "description": "Dead-shorting the 48-million-ton continuous-time keel directly into the Caesura gap, reigniting physical reality in golden fury.",
    "file_name": "caesura_art_142_10_planck_ignition.jpg",
    "relative_path": "/art/generative/caesura_art_142_10_planck_ignition.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_143",
    "plate_number": 143,
    "title": "Reality Re-Crystallizing Atom by Atom",
    "cycle_id": "10_planck_ignition",
    "cycle_title": "The Planck Ignition Climax & Spacetime Striking",
    "act": "Act XII",
    "description": "Dead-shorting the 48-million-ton continuous-time keel directly into the Caesura gap, reigniting physical reality in golden fury.",
    "file_name": "caesura_art_143_10_planck_ignition.jpg",
    "relative_path": "/art/generative/caesura_art_143_10_planck_ignition.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_144",
    "plate_number": 144,
    "title": "Chief Marcus Ward's Final Breaker Throw",
    "cycle_id": "10_planck_ignition",
    "cycle_title": "The Planck Ignition Climax & Spacetime Striking",
    "act": "Act XII",
    "description": "Dead-shorting the 48-million-ton continuous-time keel directly into the Caesura gap, reigniting physical reality in golden fury.",
    "file_name": "caesura_art_144_10_planck_ignition.jpg",
    "relative_path": "/art/generative/caesura_art_144_10_planck_ignition.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_145",
    "plate_number": 145,
    "title": "The Burning Copper Keel Breaking Free",
    "cycle_id": "10_planck_ignition",
    "cycle_title": "The Planck Ignition Climax & Spacetime Striking",
    "act": "Act XII",
    "description": "Dead-shorting the 48-million-ton continuous-time keel directly into the Caesura gap, reigniting physical reality in golden fury.",
    "file_name": "caesura_art_145_10_planck_ignition.jpg",
    "relative_path": "/art/generative/caesura_art_145_10_planck_ignition.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_146",
    "plate_number": 146,
    "title": "Sub-Harmonic Echo of the Reignited World",
    "cycle_id": "10_planck_ignition",
    "cycle_title": "The Planck Ignition Climax & Spacetime Striking",
    "act": "Act XII",
    "description": "Dead-shorting the 48-million-ton continuous-time keel directly into the Caesura gap, reigniting physical reality in golden fury.",
    "file_name": "caesura_art_146_10_planck_ignition.jpg",
    "relative_path": "/art/generative/caesura_art_146_10_planck_ignition.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_147",
    "plate_number": 147,
    "title": "Golden Plasma Pushing Back Eternal Void",
    "cycle_id": "10_planck_ignition",
    "cycle_title": "The Planck Ignition Climax & Spacetime Striking",
    "act": "Act XII",
    "description": "Dead-shorting the 48-million-ton continuous-time keel directly into the Caesura gap, reigniting physical reality in golden fury.",
    "file_name": "caesura_art_147_10_planck_ignition.jpg",
    "relative_path": "/art/generative/caesura_art_147_10_planck_ignition.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_148",
    "plate_number": 148,
    "title": "Tick N Plus One Rendered in Pure Fire",
    "cycle_id": "10_planck_ignition",
    "cycle_title": "The Planck Ignition Climax & Spacetime Striking",
    "act": "Act XII",
    "description": "Dead-shorting the 48-million-ton continuous-time keel directly into the Caesura gap, reigniting physical reality in golden fury.",
    "file_name": "caesura_art_148_10_planck_ignition.jpg",
    "relative_path": "/art/generative/caesura_art_148_10_planck_ignition.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_149",
    "plate_number": 149,
    "title": "The Broken Chains of Asteroid Two",
    "cycle_id": "10_planck_ignition",
    "cycle_title": "The Planck Ignition Climax & Spacetime Striking",
    "act": "Act XII",
    "description": "Dead-shorting the 48-million-ton continuous-time keel directly into the Caesura gap, reigniting physical reality in golden fury.",
    "file_name": "caesura_art_149_10_planck_ignition.jpg",
    "relative_path": "/art/generative/caesura_art_149_10_planck_ignition.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  },
  {
    "id": "art_150",
    "plate_number": 150,
    "title": "Dawn Over the Peres-Theta Horizon",
    "cycle_id": "10_planck_ignition",
    "cycle_title": "The Planck Ignition Climax & Spacetime Striking",
    "act": "Act XII",
    "description": "Dead-shorting the 48-million-ton continuous-time keel directly into the Caesura gap, reigniting physical reality in golden fury.",
    "file_name": "caesura_art_150_10_planck_ignition.jpg",
    "relative_path": "/art/generative/caesura_art_150_10_planck_ignition.jpg",
    "width": 1280,
    "height": 720,
    "aspect_ratio": "16:9"
  }
];
